import { render, staticRenderFns } from "./PersonLoanView.vue?vue&type=template&id=aae62092"
import script from "./PersonLoanView.vue?vue&type=script&lang=js"
export * from "./PersonLoanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aae62092')) {
      api.createRecord('aae62092', component.options)
    } else {
      api.reload('aae62092', component.options)
    }
    module.hot.accept("./PersonLoanView.vue?vue&type=template&id=aae62092", function () {
      api.rerender('aae62092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Clientes/PersonLoanView.vue"
export default component.exports